// extracted by mini-css-extract-plugin
module.exports = {"xrColorPrimary":"#2362FB"};